import React, { Component } from "react";
import { connect } from "react-redux";
import EditAdminProfile from "../components/EditAdminProfile";
import { close_snack_bar } from "../../../../store/actions/snackbarActions";
import { updateProfile } from "../../adminActions";

export class EditAdminProfileCont extends Component {
    render() {
        return <EditAdminProfile {...this.props} />;
    }
}

export const mapStateToProps = (store) => {
    return {
        login: store.login,
        loader: store.loader,
        snackbar: store.snackbar,
        client: store.client,
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        close_snack_bar: () => {
            dispatch(close_snack_bar());
        },
        updateProfile: (token, id, data) => {
            dispatch(updateProfile(token, id, data));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditAdminProfileCont);
